import { render, staticRenderFns } from "./SaleLinks.vue?vue&type=template&id=23120066&scoped=true&"
import script from "./SaleLinks.vue?vue&type=script&lang=js&"
export * from "./SaleLinks.vue?vue&type=script&lang=js&"
import style0 from "./SaleLinks.vue?vue&type=style&index=0&id=23120066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23120066",
  null
  
)

export default component.exports